import { NavLink } from "react-router-dom";
import "./Menu.css";

export default function Menu() {
  return (
    <header className="menu-bar">
      <NavLink to="/conversion" className="menu-brand">
  Pdf-Convert
</NavLink>


      <nav className="menu-links">
        <NavLink
          to="/conversion"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Conversion
        </NavLink>

        <NavLink
          to="/reduction"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Réduction d’image
        </NavLink>
      </nav>
    </header>
  );
}
